import { Button } from '@/components/ui/button'
import { Body1, Heading1, Heading4 } from '@/components/ui/typography'
import RobotImage from 'assets/images/robot.png'
import { Link } from 'components/Link'

import FiveZeroZeroStyleWrapper from './styles'

const ServiceUnavailable = () => (
  <FiveZeroZeroStyleWrapper className='iso500Page'>
    <div className='iso500Content'>
      <Heading1>503</Heading1>
      <Heading4>Server unavailable</Heading4>
      <Body1>Something went wrong. Please try again later.</Body1>
      <Link to='/'>
        <Button>Back home</Button>
      </Link>
    </div>

    <div className='iso500Artwork'>
      <img alt='robot' src={RobotImage} />
    </div>
  </FiveZeroZeroStyleWrapper>
)

export default ServiceUnavailable
